export default __webpack_public_path__ + "static/media/blogs.bc0180c4.svg";